module.exports = __webpack_public_path__ + "static/card-7246fcc57b4319304886dc45707e243a.png";